import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('universal-associations-select', {
  library: 'universal-associations-select'
});